const STORAGE_KEY = 'connect-ws-organisation-id';
const EVENT_NAME = 'cogneed:connect:orgId';

export function getPersistedOrganisationId(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function notifyOrganisationId(organisationId: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, organisationId);
  } catch {
    // ignore storage errors
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { organisationId } }));
}

export function subscribeToOrganisationIdUpdates(
  callback: (organisationId: string) => void,
): () => void {
  const handler = (event: Event) => {
    const { organisationId } = (event as CustomEvent<{ organisationId: string }>).detail;
    callback(organisationId);
  };
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
